module.exports = __webpack_public_path__ + "img/724-1023fc.png";